import React      from 'react';
import CSSModules from 'react-css-modules';

import style        from './style.scss';
import navigator    from '../../services/navigator';

const ShowModuleList = props => {
    if(!props.show) return null;

        return (
            <div>
            {props.modules.map((module, index) => {
                    const subjectStyle = !props.selectedModule || (props.selectedModule && props.selectedModule.id == module.id) ? 'module-box' : 'unselected-module-box';

                    if (props.showEventTypes && module.courses.filter(c => props.showEventTypes.includes(c.type)).length === 0)
                        return null;

                    return (
                        <div className={style['module-box-container']}>
                            <article key={ index }
                                     className={ style[subjectStyle]}
                                     style={ props.moduleBackgroundStyle(module) }
                                     onClick={ props.onClick.bind(this, module) }
                            >
                            </article>
                            <div className={style['module-title-box']} style={props.moduleTitleBoxStyle(module)} onClick={ props.onClick.bind(this, module) }>
                                <h2 className={style['module-title']}>{ module.name }</h2>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
};

class ModuleCourseTabList extends React.Component {

    _getModuleBackgroundStyle(module) {

        if(module.background_image){
            return {
                backgroundImage: `url('/api/v1/modules/${module.id}/image')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
            };
        } else {
            return {
                backgroundColor: module.hex_colour
            };
        }

    }

    _getModuleStyle(module) {

        const defaultStyle = {backgroundColor: module.hex_colour};
        if(this.props.selectedModule && this.props.selectedModule.id !== module.id){
            return {
                backgroundColor: '#999999'
            }
        } else {
            return defaultStyle;
        }

    }

    render() {

        return (
            <div>
                <h2 className={style["section-heading"]}>Subjects</h2>

                <article id="subject-tile-list" className={style['module-content']}>
                    <ShowModuleList
                        showEventTypes={this.props.showEventTypes}
                        show={this.props.modules.length > 0}
                        selectedModule={this.props.selectedModule}
                        modules={this.props.modules}
                        onClick={this.props.onClick.bind(this)}
                        moduleBackgroundStyle={this._getModuleBackgroundStyle.bind(this)}
                        moduleTitleBoxStyle={this._getModuleStyle.bind(this)}
                    />
                </article>

            </div>
        );
    }
}

export default CSSModules(ModuleCourseTabList, style);


// WEBPACK FOOTER //
// ./components/MarketingModuleList/index.js